import {useAppSelector} from '@/hooks';

export const usePosterHasAudio = (): boolean => {
  const audioHashmap = useAppSelector((state) => {
    return state.posterEditor.posterObject?.audioClips.audioItemsHashMap;
  });

  if (!audioHashmap) {
    return false;
  }

  return Object.keys(audioHashmap).length > 0;
};
